import React, { useState, useEffect, useRef } from "react";
import dayjs from "dayjs";
import { BASE_URL, getImageUrlWithMaxWidth, randomPick } from "@src/utils";

import HallCard from "./HallCard";
import KakaoMapWithModal from "@src/components/common/map/KakaoMapWithModal";
import HallImgCarousel from "./HallImgCarousel";
import HallMainInformation from "./HallMainInformation";

import copy from "@assets/images/icon/ic-copy.svg";
import "@src/components/common/bottomFixedModal/bottomFixedModal.scss";
import "./infoTab.scss";
import { IHallDetail } from "@src/types/weddingHall";
import HorizontalPartnerList from "@src/components/common/horizontalPartnerList/HorizontalPartnerList";
import { getWeddingHallRegional } from "@src/api/weddingHall/weddingHall";
import Blank from "@src/components/common/blank/Blank";
import { getAdvertiseHallList } from "@src/api/weddingHall/advertise";
import BottomFixedModal from "@src/components/common/bottomFixedModal/BottomFixedModal";
import axios from "@src/api/axios";

//이미지
import elevator from "@assets/icons/weddinghall/elevator.png";
import traditional_ceremony from "@assets/icons/weddinghall/traditional_ceremony.png";
import waiting_p from "@assets/icons/weddinghall/parents_waiting_room.png";
import sub_waiting from "@assets/icons/weddinghall/sub_waiting_room.png";
import waitingroom from "@assets/icons/weddinghall/waiting_room.png";
import { useSelector } from "react-redux";
import { realtimeBooking } from "@src/@slice/realtimeBookingSlice";
import NotificationArccodion from "@src/components/booking/realtimeBooking/notification/NotificationArccodion";
import { useNavigate } from "react-router-dom";
import { postHallDiscountInquiryChat } from "@src/api/weddingHall/chat";

const dayMapping = {
  SUNDAY: "일요일",
  MONDAY: "월요일",
  TUESDAY: "화요일",
  WEDNESDAY: "수요일",
  THURSDAY: "목요일",
  FRIDAY: "금요일",
  SATURDAY: "토요일",
};

type Props = {
  type?: "default" | "preview";
  data: IHallDetail;
  comparisonData?: any | null;
  partnerProfileId?: string;
  onClickTab: (idx) => void;
};

const InfoTab = ({
  type = "default",
  data,
  partnerProfileId,
  comparisonData,
  onClickTab,
}: Props) => {
  const navigate = useNavigate();
  const hallCardComponentWrap = useRef<HTMLDivElement>(null);
  const hallTabComponentTop = useRef<number>(0);
  const facilityWrap = useRef<HTMLDivElement>(null);
  const facilityTop = useRef<number>(0);
  const hallRefs = useRef([]); // 개별홀 카드 ref 배열
  const refTabs = useRef<HTMLDivElement>(null);
  const todayKey = dayjs().locale("en").format("dddd").toUpperCase();

  const hallData = useSelector(realtimeBooking).hall;

  const findChangePart = (data) => {
    const typeCount = { updated: 0, deleted: 0, created: 0, unchanged: 0 };

    if (typeof data === "object" && !Array.isArray(data)) {
      const keys = Object.keys(data);
      keys.forEach((key) => {
        const type = data[key]?.type || "unchanged";
        typeCount[type]++;
      });

      // 우선순위 순으로 반환
      const priority = ["updated", "deleted", "created", "unchanged"];
      for (const type of priority) {
        if (typeCount[type] > 0) {
          return type;
        } else {
          return null;
        }
      }
    } else {
      // 배열일 때 수정하기
      return "";
    }
  };

  //어드민 preview 비교를 위한 데이터
  const safeComparisonData = comparisonData || {
    amenities: {},
    address: {},
    address2: {},
    subways: {},
    parking: {},
    operationTime: [],
    individualHalls: [],
  };

  const [individualHalls, setIndividualHalls] = useState([]); // 개별홀 정보
  const [addressForInvitation, setAddressForInvitation] = useState<{
    subway?: string;
    car?: string;
    bus?: string;
  }>({}); // 청첩장용 주소
  const [operationTime, setOperationTime] = useState([]);
  const [facilityInfo, setFacilityInfo] = useState([]);
  const [visitInfo, setVisitInfo] = useState([]);
  const [scrollLock, setScrollLock] = useState(false); // 스크롤 이벤트 동작 막기
  const [isSticky, setIsSticky] = useState(false); // 개별홀 뱃지탭 스티키 여부
  const [activeHallTag, setActiveHallTag] = useState(0); // 개별홀 뱃지
  const [showAdressModal, setShowAdressModal] = useState(false); // 청첩장주소 복사 바텀시트
  const [showAllOperationTime, setShowAllOperationTime] = useState(false);
  const [badges, setBadges] = useState([]);
  const [aroundHallList, setAroundHallList] = useState([]); // 주변 웨딩홀
  const [showDiscountInquiryModal, setShowDiscountInquiryModal] = useState(false); // 할인 견적 문의 바텀시트

  const getSummaries = (specialFeatures) => {
    const summaries = specialFeatures.map((item) => {
      return {
        iconUrl: getImageUrlWithMaxWidth(item.icon, 64),
        textArr: item.features,
      };
    });
    return summaries;
  };

  // 스크롤 시 헤더 상단 고정 및 개별홀 태그 active 상태 변경
  useEffect(() => {
    if (data.profile !== null && hallCardComponentWrap.current && facilityWrap.current) {
      hallTabComponentTop.current = hallCardComponentWrap.current.offsetTop;
      facilityTop.current = facilityWrap.current.offsetTop;

      const handleScroll = () => {
        const currentScrollY =
          window.scrollY || window.document.body.scrollTop || window.pageYOffset;
        if (currentScrollY > hallTabComponentTop.current - 156) {
          //헤더높이 106 + 개별홀 탭높이 50를 더한 값..
          setIsSticky(true);
        } else {
          setIsSticky(false);
        }

        if (currentScrollY >= facilityTop.current - 200) {
          setIsSticky(false);
        }

        if (scrollLock === false) {
          for (let i = 0; i < hallRefs.current.length; i++) {
            const cardElement = hallRefs.current[i];
            const cardTop = cardElement.getBoundingClientRect().top + window.pageYOffset;
            const headerHeight = refTabs.current.offsetHeight + 52 + 55;

            if (currentScrollY >= cardTop - headerHeight) {
              setActiveHallTag(i);
            }
          }
        }
      };

      window.addEventListener("scroll", handleScroll);

      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }
  }, [scrollLock, data.profile, hallRefs.current.length]);

  useEffect(() => {
    const badgeList = [];
    if (data.consultingSlotsDisplayed && data.consultingUsed) {
      badgeList.push("즉시 방문 예약");
    }
    if (data.contractUsed) {
      badgeList.push("즉시 잔여타임 선점");
    }
    setBadges(badgeList);
    if (data.profile !== null) {
      const facilities = data.profile?.amenities; // 부대시설
      const subways = data.profile?.subways[0] || {
        lineName: "",
        stationName: "",
        walkingTimeMinutes: "",
      };
      const parkings = data.profile?.parking;

      const todayOperationInfo =
        data.partnerOpens?.filter(
          (date: { dayOfWeek: string }) => date.dayOfWeek === todayKey,
        )[0] || null;

      setOperationTime(data.partnerOpens || []);
      setIndividualHalls(data.profile?.individualHalls || []);
      setAddressForInvitation(data.profile?.invitation || {});
      setFacilityInfo([
        {
          key: "elevatorCount",
          title: "엘리베이터",
          value: `${facilities?.elevatorCount}대`,
          type: safeComparisonData?.amenities?.elevatorCount?.type || null,
          src: elevator,
        },
        {
          key: "pyebaekRoom",
          title: "폐백실",
          value: facilities?.pyebaekRoom,
          type: safeComparisonData?.amenities?.pyebaekRoom?.type || null,
          src: traditional_ceremony,
        },
        {
          key: "honjooRoom",
          title: "혼주대기실",
          value: facilities?.honjooRoom,
          type: safeComparisonData?.amenities?.honjooRoom?.type || null,
          src: waiting_p,
        },
        {
          key: "subWaitingRoom",
          title: "서브대기실",
          value: facilities?.subWaitingRoom,
          type: safeComparisonData?.amenities?.subWaitingRoom?.type || null,
          src: sub_waiting,
        },
        {
          key: "guestSpace",
          title: "대기공간",
          value: facilities?.guestSpace,
          type: safeComparisonData?.amenities?.guestSpace?.type || null,
          src: waitingroom,
        },
      ]);

      setVisitInfo([
        {
          key: "address",
          title: "주소",
          value: data.profile?.address + " " + data.profile?.address2,
          type:
            findChangePart({
              adress: safeComparisonData?.address,
              address2: safeComparisonData?.address2,
            }) || null,
        },
        {
          key: "subways",
          title: "지하철",
          value:
            subways?.stationName &&
            subways?.walkingTimeMinutes &&
            `${subways?.lineName} ${subways?.stationName}역 ${subways?.walkingTimeMinutes}분`,
          type: findChangePart(safeComparisonData?.subways) || null,
        },
        {
          key: "parkings",
          title: "주차",
          value: `내부 ${parkings?.inner}대 \n외부 ${parkings?.outer}대 \n${parkings?.notice} \n대절버스 주차${parkings?.busRent ? "가능" : "불가"}${parkings?.busRentNotice ? `(${parkings?.busRentNotice})` : ""}`,
          type: findChangePart(safeComparisonData?.parking) || null,
        },
        {
          key: "todayOperationInfo",
          title: "운영시간",
          value: `${dayMapping[todayOperationInfo?.dayOfWeek]} ${todayOperationInfo?.holiday ? "휴무" : todayOperationInfo?.startTime + " ~ " + todayOperationInfo?.closeTime}`,
          type: findChangePart(safeComparisonData?.operationTime) || null,
        },
      ]);
    }
  }, [data]);

  // 주변 웨딩홀 추천 데이터 가져오기
  useEffect(() => {
    (async () => {
      const partnerRes = await axios.get<{ item: { region: string }[] }>(
        `${BASE_URL}/v3/200107/partners?uuids=${data.partnerUuid}`,
      );
      if (data !== null && partnerRes.data.item.length > 0) {
        const regions = partnerRes.data.item[0].region.replace(" ", "-");
        const adData = await getAdvertiseHallList("NEARBY_RECOMMEND", [regions]);
        getWeddingHallRegional([data.partnerUuid]).then((data) => {
          const adList = adData.item.results.map((partner) => {
            const region = `${partner.region} ${partner.subRegion}`;
            return {
              coverUrl: partner.partnerProfileImages[0].url,
              region,
              partnerUuid: partner.partnerUuid,
              partnerName: partner.partnerProfileName,
              isLiked: partner.isLike,
              isAdvertise: true,
              adCode: partner.adCode,
              adName: partner.adName,
              type: 2, // 웨딩홀
            };
          });
          const hallList = data.item.map((partner) => {
            const region = `${partner.mainRegion} ${partner.subRegion}`;
            return {
              coverUrl: partner.coverUrl,
              region,
              partnerUuid: partner.uuid,
              partnerName: partner.name,
              isLiked: partner.isLiked,
              type: 2, // 웨딩홀
            };
          });
          const randomList = randomPick(hallList, 20);
          setAroundHallList(adList.concat(randomList));
        });
      }
    })();
  }, [data]);

  // 개별홀 태그 클릭 시 스크롤 이동 및 태그 active
  const handleBadgeClick = (idx) => {
    setActiveHallTag(idx); //acitve 태그 변경
    setScrollLock(true); // 스크롤 이벤트 막기

    const targetCardElement = hallRefs.current[idx]; // 보여질 개별홀 카드
    const headerHeight = refTabs.current.offsetHeight + 52 + 55;
    const elementTop = targetCardElement.getBoundingClientRect().top + window.pageYOffset;
    const scrollToPosition = elementTop - headerHeight;

    window.scrollTo({ top: scrollToPosition, behavior: "smooth" });
    setTimeout(() => setScrollLock(false), 5000); //다시 스크롤 이벤트 허용
  };

  return (
    <>
      <HallImgCarousel
        type="hall"
        indicatorType="dot"
        height={375}
        imgs={data.profile?.representativeImages || [{ url: data.coverUrl, title: data.bizName }]}
        imgClick={() => {
          onClickTab(3);
        }}
        isDiscount={data.benefits.some((benefit) => benefit.tag === "할인")}
      />
      <HallMainInformation
        type="weddinghall"
        availableContract={
          data.consultingSlotsDisplayed && data.consultingUsed && hallData.useAutoApproval
        } //번개태그 보여주는 용도
        isWeeklyReservationActive={data.isWeeklyReservationActive}
        productBtn={{ name: "할인 견적 문의", func: () => setShowDiscountInquiryModal(true) } }
        partnerName={data.profile?.name || data.bizName}
        benefits={data.benefits}
        summaries={getSummaries(data.specialFeatures)}
        {...(data.totalAmount > 0
          ? {
              price: {
                discountRate: data.discountRate,
                minPrice: data.minPrice,
                totalAmount: data.totalAmount,
              },
            }
          : {})}
      />
      {data.profile !== null ? (
        <div className="tap-infomation-wrap hide-scroll">
          <h2>홀 종류</h2>
          <div
            ref={refTabs}
            className={`hallcard-badge-wrap hide-scroll ${isSticky ? "sticky" : ""}`}
          >
            {individualHalls.length > 0 &&
              individualHalls.map((hall, idx) => (
                <div
                  key={hall.id}
                  className={`badge badge-brown-line ${activeHallTag === idx ? "active" : ""}`}
                  onClick={() => handleBadgeClick(idx)}
                >
                  {hall.name}
                </div>
              ))}
          </div>
          <div className="hallcard-layout-wrap" ref={hallCardComponentWrap}>
            {individualHalls.length > 0 &&
              individualHalls.map((hallData, idx) => {
                const hall = safeComparisonData?.individualHalls[idx];
                return (
                  <div key={hallData.name} ref={(el) => (hallRefs.current[idx] = el)}>
                    <HallCard
                      type={type}
                      hallData={hallData}
                      partnerProfileId={partnerProfileId}
                      partnerId={data.partnerId}
                      compareClassName={{
                        name: `comparison-box ${hall?.name.type}`,
                        regularPrice: `comparison-box ${findChangePart({ rentalFee: hall?.regularPrice?.rentalFee, mealFee: hall?.regularPrice?.adultDrinkFee })}`,
                        weddingGapMinutes: `comparison-box ${findChangePart(hall?.weddingGapMinutes)}`,
                      }}
                    />
                  </div>
                );
              })}
          </div>
          <div className="divider" />
          <div className="facilities-wrap" ref={facilityWrap}>
            <InfoList title="부대시설">
              <ul className="facilities-info-list">
                {facilityInfo &&
                  facilityInfo
                    .filter((idx) => idx.value !== false)
                    .map((info) => (
                      <li key={info.key} className={`comparison-box ${info.type} center`}>
                        <img src={info.src} alt={info.title} width={28}></img>
                        <span>
                          {info.title}
                          {info.value === true ? "" : " " + info.value}
                        </span>
                      </li>
                    ))}
              </ul>
            </InfoList>
          </div>
          <div className="divider" />
          <div className="visit-info-wrap">
            <InfoList title="방문안내">
              <KakaoMapWithModal target={data.profile.name} />
              <ul className="visit-info-list">
                {visitInfo.map((info, idx) => (
                  <>
                    {info.value.length > 0 && (
                      <li key={info.title} className={`comparison-box ${info.type}`}>
                        <p>{info.title}</p>
                        <p className={`info-value-${idx}`}>
                          {info.value}
                          {idx === 3 && (
                            <span
                              className={`icon ${showAllOperationTime ? "icon-chevron-up-gray900" : "icon-chevron-down-gray900"}`}
                              onClick={() => setShowAllOperationTime((prev) => !prev)}
                            />
                          )}
                          <br />
                          {idx === 3 && showAllOperationTime && (
                            <AllOperationTime operationTime={operationTime} />
                          )}
                          {idx === 0 &&
                            (addressForInvitation.subway ||
                              addressForInvitation.car ||
                              addressForInvitation.bus) && (
                              <span
                                className="clickable-text"
                                onClick={() => setShowAdressModal(true)}
                              >
                                청첩장용 주소
                              </span>
                            )}
                        </p>
                      </li>
                    )}
                  </>
                ))}
              </ul>
            </InfoList>
          </div>
          {data.isWeeklyReservationActive === true && (
            <>
              <div className="divider" />
              <div className="weekly-alarm-wrap">
                <InfoList title="주단위 예약 웨딩홀">
                  <p className="weekly-alarm-desc">
                    웨딩홀이 지정한 예약 오픈일에 방문 예약을 시도할 수 있는 주단위 예약
                    웨딩홀입니다.
                  </p>
                  <div className="weekly-stepper">
                    {[
                      "방문 예약 \n신청",
                      "예약 오픈일에 \n선착순 예약 진행",
                      "방문 예약 \n완료",
                    ].map((step, idx) => (
                      <div className="step">
                        <div className="stepper-circle bold">{idx + 1}</div>
                        <span className="stepper-label">{step}</span>
                      </div>
                    ))}
                  </div>
                  <NotificationArccodion
                    isOpen={true}
                    title="안내드려요."
                    useArccodion={false}
                    children={
                      <ul className="weekly-alarm-notice">
                        <li>예약 시도는 방문 예약 신청 순으로 진행됩니다.</li>
                        <li>인기 웨딩홀일수록 예약 일정이 빠르게 마감될 수 있습니다. </li>
                        <li>
                          원하는 일정으로 예약 실패 시 일정 조율을 위해 웨딩홀 담당자가 빠르게
                          연락드릴 예정입니다.
                        </li>
                      </ul>
                    }
                  />
                </InfoList>
              </div>
            </>
          )}

          {aroundHallList.length > 0 && (
            <>
              <Blank height={12} color="#f2f2f2" />
              <div className="common-wrap" style={{ paddingTop: 40 }}>
                <HorizontalPartnerList
                  title="이 주변 웨딩홀 추천"
                  list={aroundHallList}
                  updateLikeOptimistic={(partnerUuid) => {}}
                />
              </div>
            </>
          )}
          {showAdressModal && (
            <AdressBottomSheet isShow={showAdressModal} hideModal={() => setShowAdressModal(false)}>
              <div className="address-list-wrap">
                {Object.keys(addressForInvitation) &&
                  Object.keys(addressForInvitation).map((way) => (
                    <div key={way}>
                      <h2 className="bold">
                        {way
                          .replaceAll("subway", "지하철")
                          .replaceAll("bus", "버스")
                          .replaceAll("car", "자가용")}
                      </h2>
                      <p
                        className="subscribe"
                        style={{ whiteSpace: "pre-wrap", lineHeight: "19.5px", marginTop: "8px" }}
                      >
                        {addressForInvitation[way]}
                      </p>
                    </div>
                  ))}
              </div>
            </AdressBottomSheet>
          )}
          {showDiscountInquiryModal && (
            <BottomFixedModal
              className="discount-inquiry-bottomsheet"
              isShow={showDiscountInquiryModal}
              isTransition={true}
              title="💒"
              // title={"대관료·식대 할인 견적 문의"}
              hideModal={() => setShowDiscountInquiryModal(false)}
            >
              <div className="discount-inquiry-noti-wrap">
                <div className="noti-wrap">
                  <p className="title bold">
                    대관료·식대 할인 견적 문의
                  </p>
                  <p className="desc">
                    웨딩홀 견적은 예식일정, 보증인원 등 조건에 따라 달라집니다. 문의를 남겨주시면 확인 후 안내해 드릴게요.
                  </p>

                  <div className="btn-wrap btn-wrap-columns-1-1 btn-wrap-no-padding">
                    <button
                      className="btn btn-giant btn-full btn-red0"
                      onClick={() => setShowDiscountInquiryModal(false)}
                    >
                      나중에
                    </button>
                    <button
                      className="btn btn-giant btn-full btn-red500"
                      onClick={() => {
                        postHallDiscountInquiryChat(data.profile?.name || data.bizName)
                          .then(() => {
                            navigate('/mypage/chat');
                          })
                          .catch((err) => {
                            console.error(err);
                          });

                      }}
                    >
                      1:1 채팅 문의
                    </button>
                  </div>
                </div>
              </div>
            </BottomFixedModal>
          )}
        </div>
      ) : (
        <Blank height={100} />
      )}
    </>
  );
};

export default InfoTab;

const InfoList = ({ title, children }) => {
  return (
    <div className="info-list-wrap">
      <p className="title bold">{title}</p>
      {children}
    </div>
  );
};

//청첩장용 주소 바텀시트
const AdressBottomSheet = ({ isShow, hideModal, children }) => {
  const modalContentRef = useRef(null);
  const copyToClipboard = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        alert("주소가 클립보드에 복사되었습니다.");
      })
      .catch((err) => {
        alert("복사에 실패했습니다.");
      });
  };

  const copyAdress = () => {
    const textContent = modalContentRef.current.innerText;
    copyToClipboard(textContent);
  };

  return (
    <div className={`bottom-fixed-modal-wrap ${isShow ? "show" : ""}`}>
      <div className="overlay" onClick={hideModal}></div>
      <div className={`bottom-fixed-modal`} style={{ paddingTop: "22px" }}>
        <h2 className="modal-title">
          청첩장용 주소
          <img
            src={copy}
            alt=""
            width={18}
            onClick={copyAdress}
            style={{ verticalAlign: "text-top", marginLeft: "4px", paddingTop: "2px" }}
          />
        </h2>
        <div className="modal-content" ref={modalContentRef} style={{ padding: "16px 20px" }}>
          {children}
        </div>
      </div>
    </div>
  );
};

const AllOperationTime = ({ operationTime }) => {
  return (
    <>
      {operationTime.map((date, idx) => (
        <span key={date.key} className={`opreration-time key-${idx}`}>
          {dayMapping[date.dayOfWeek]}{" "}
          {date.holiday ? "휴무" : date.startTime + " ~ " + date.closeTime}
        </span>
      ))}
    </>
  );
};
